import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteResourceQueue } from '../../api/production-request-api/index.js';
import { useAppContext } from '../../providers';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for deleting a resource queue.
 */
export const useDeleteResourceQueue = () => {
  const { selectedResource } = useAppContext();
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call the deleteResourceQueue api.
     * @param {object} params - Parameters for deleting a resource queue.
     * @param {Pella.ProductionRequestAPI.Queue['id']} params.queueId - ID of the queue to unassign.
     * @param {Pella.ProductionRequestAPI.Resource['id']} [params.resourceId] - ID of the resource.
     */
    mutationFn: ({ queueId, resourceId }) =>
      deleteResourceQueue({ queueId, resourceId: resourceId ?? selectedResource }),
    onSuccess: (_data, { resourceId }) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RESOURCE_QUEUES, resourceId ?? selectedResource] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RESOURCE_DATA] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.QUEUE_DATA] });
    },
  });
};
